// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 80 ? "fdd47866" : chunkId) + "." + {"80":"dd276273f99c89c1","268":"a6653838c5f8936c","358":"1126f9ab6c5b8814","647":"256109ef713f8e0f"}[chunkId] + ".js";
};